import { Component, input, signal } from '@angular/core';

@Component({
  selector: 'simple-collapsible',
  standalone: true,
  imports: [],
  templateUrl: './simple-collapsible.component.html',
  styleUrl: './simple-collapsible.component.scss'
})
export class CollapsibleComponent {
  title = input<string>('Click to toggle');
  isOpen = signal<boolean>(false);

  toggle(): void {
    this.isOpen.update(value => !value);
  }
}
